import React, { ReactElement, useEffect, useState } from 'react';
import className from 'classnames/bind';
import { connect } from 'react-redux';
import { InView } from 'react-intersection-observer';
import styles from './index.pcss';
import { showModal, hideModal } from '../../../actions/shared/modal';
import Modal from '../../../components/common/Modal';
import { getAllReviews } from '../../../actions/ratings';
import ReviewDetails from './ReviewDetails';
import ViewAllReviewsDesktop from './ViewAllReviewsDesktop';
import CustomerPhotoGridModal from './ReviewCustomerPhotoGridModal/CustomerPhotoGridModal';
import ReviewSinglePhotoModal from './ReviewSinglePhotoModal/ReviewSinglePhotoModal';
import { SortByReviews } from './constants';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
import { getProductItemPDP, gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';

const cx = className.bind(styles);

const mapDispatchToProps = dispatch => {
  return {
    getAllReviews: (reqObj = {}) => dispatch(getAllReviews(reqObj)),
    showModal: (name, config) => dispatch(showModal(name, config)),
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};
const mapStateToProps = state => ({});
const connector = connect(mapStateToProps, mapDispatchToProps);
const ProductReviewsDesktop = ({
  totalRatingCount,
  totalStarCount,
  isProgressBar,
  rateData,
  isDesktop,
  customerWords,
  textReview,
  imageReview,
  noReviews,
  subRating,
  titleD,
  productCode,
  productName,
  product_id,
  product_brick,
  aggregateRating,
  images,
  getAllReviews,
  showModal,
  hideModal,
  totalReviews,
  productData
}: {}): ReactElement => {
  const slicedTextReview =
    textReview && textReview.length > 2 ? textReview.slice(0, 2) : textReview;
  const [viewallReviews, setViewAllReviews] = useState(false);
  const [viewPhotoReviews, setPhotoReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const textNumberOnPhotos = (imageReview?.totalReviews > 5 && imageReview?.totalReviews - 5) || 0;
  const photosArrayToShow =
    imageReview?.totalReviews > 5
      ? imageReview?.productReviewImages.slice(0, 5)
      : imageReview?.productReviewImages;
  const productDetails = {
    productId: product_id ?? '',
    productName: productName ?? '',
    productBrick: product_brick ?? ''
  };

  const clickMorePhotos = () => {
    setPhotoReviews([]);
    fetchData(1);
    showModal('reviews-customer-photos-grid');
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'customer photos',
      event_label: 'clicked',
      ...(product_id.length > 0 && { product_id }),
      ...(product_brick.length > 0 && { product_brick }),
      ...(productName.length > 0 && { product_name: productName }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
  };
  const fetchData = async pageNum => {
    try {
      const filters = {
        rating: [],
        reviewWithPhotos: true,
        verifiedPurchase: false,
        sortBy: SortByReviews[0].value,
        skuId: productCode,
        pageNumber: pageNum
      };
      setLoading(true);
      const newData = await getAllReviews(filters);
      const { productReviews } = newData.reviewData;
      setPhotoReviews(prevData => [...prevData, ...productReviews]);
      setPageNumber(pageNum);
      showModal('reviews-customer-photos-grid');
    } catch (error) {
      hideModal('reviews-customer-photos-grid');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const renderSinglePhotoModal = (elObj, i) => {
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'review photos - viewed',
      event_label: elObj?.reviewId,
      ...(product_id.length > 0 && { product_id }),
      ...(productName.length > 0 && { product_name: productName }),
      ...(product_brick.length > 0 && { product_brick }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
    // Segment Push event
    segmentEventPush({
      event: 'Review Widget Interaction',
      event_category: 'reviews_rating_interactions',
      event_action: 'review photos - viewed',
      event_label: elObj?.reviewId,
      products:[{ ...getProductItemPDP(productData)}],
      // pageType: 'PDP',
      store_type: 'ajio'
    });
    
    showModal('reviews-single-photo', {
      state: {
        reviewsCollection: [],
        reviewData: elObj,
        loop: true,
        arrowEnabled: false,
        clickIndex: i
      }
    });
  };

  const triggerImpression = inView => {
    if (inView) {
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews_rating_interactions',
        event_action: 'reviews widget',
        event_label: 'seen',
        ...(product_id?.length > 0 && { product_id }),
        ...(product_brick?.length > 0 && { product_brick }),
        ...(productName?.length > 0 && { product_name: productName }),
        pageType: 'PDP',
        store_type: 'ajio'
      });
      // Segment Push Event
      segmentEventPush({
        event: 'Review Widget Viewed',
        event_category: 'reviews_rating_interactions',
        event_action: 'reviews widget',
        event_label: 'seen',
        products:[{ ...getProductItemPDP(productData)}],
        avg_ratings_of_reviews: '',
        count_of_people_found_useful: '',
        no_of_ratings_collected: '',
        review_count: '',
        review_with_images: '',
        size_and_fit_subrating: '',
        value_for_money_subrating: '',
        screen_name: 'PDP screen',
        // pageType: 'PDP',
        store_type: 'ajio'
      });
    }
  };

  const handleViewAllReviewClick = () => {
    setViewAllReviews(!viewallReviews);
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'view all',
      event_label: 'clicked',
      ...(product_id?.length > 0 && { product_id }),
      ...(product_brick?.length > 0 && { product_brick }),
      ...(productName?.length > 0 && { product_name: productName }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
    // Segment Push event
    segmentEventPush({
      event: 'Review Widget Interaction',
      event_category: 'reviews_rating_interactions',
      event_action: 'view all',
      event_label: 'clicked',
      products:[{ ...getProductItemPDP(productData)}],
      // pageType: 'PDP',
      store_type: 'ajio'
    });
  };
  return (
    <>
      <div className={cx('reviews-container-web')}>
        <InView
          as="div"
          threshold={1}
          triggerOnce
          onChange={(inView, entry) => triggerImpression(inView)}
        >
          {imageReview?.totalReviews > 0 && (
            <div className={cx('reviews-photos-section-web')}>
              <span className={cx('reviews-section-title-web')}>
                <strong>Customer Photos</strong>
              </span>
              <div className={cx('reviews-section-customer-photos')}>
                {photosArrayToShow.length > 0 &&
                  photosArrayToShow.map((el1, i) => {
                    const imageUrlContent = el1?.imageMap?.thumbnail;
                    const imgUrl = imageUrlContent?.length > 0 && imageUrlContent[0].imageUrl;
                    if (textNumberOnPhotos > 0 && i === 4) {
                      return (
                        <div className={cx('reviews-section-image-web')} onClick={clickMorePhotos}>
                          <img
                            className={cx('reviews-section-img-web', 'blur-bg')}
                            src={`${replaceWithJioCDN(imgUrl)}`}
                            alt="Customer review image"
                          />
                          <div className={cx('reviews-section-textimage-web')}>
                            + {textNumberOnPhotos}
                          </div>
                        </div>
                      );
                    }
                    return (
                      <div className={cx('reviews-section-image-web')} onClick={clickMorePhotos}>
                        <img
                          className={cx('reviews-section-img-web')}
                          src={`${replaceWithJioCDN(imgUrl)}`}
                          alt="Customer review image"
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
          {!viewallReviews && (
            <>
              <div className={cx('reviews-review-section-web')}>
                <div className={cx('reviews-header')}>
                  <span className={cx('reviews-section-title-web')}>
                    <strong>Top Reviews</strong>
                  </span>
                </div>
                {slicedTextReview?.length > 0 &&
                  slicedTextReview.map(el => {
                    return (
                      <ReviewDetails
                        renderSinglePhotoModal={renderSinglePhotoModal}
                        key={el.id}
                        isDesktop
                        reviewData={el}
                        single={false}
                        productDetails={productDetails}
                      />
                    );
                  })}
              </div>
              <div className={cx('reviews-viewall-section')}>
                <div onClick={handleViewAllReviewClick} className={cx('reviews-viewall-button')} tabIndex={0} role='button'>
                  <strong>{`VIEW ALL REVIEWS (${totalReviews})`}</strong>
                </div>
              </div>
            </>
          )}
        </InView>
        {viewallReviews && (
          <ViewAllReviewsDesktop
            totalRatingCount={totalRatingCount}
            totalStarCount={totalStarCount}
            isProgressBar={isProgressBar}
            rateData={rateData}
            isDesktop
            customerWords={customerWords}
            imageReview={imageReview}
            noReviews={noReviews}
            subRating={subRating || ''}
            titleD={titleD}
            productCode={productCode}
            productName={productName}
            product_id={product_id}
            product_brick={product_brick}
            images={images}
            aggregateRating={aggregateRating || ''}
            closeModal={() => setViewAllReviews(!viewallReviews)}
            showModal={showModal}
            hideModal={hideModal}
            productData={productData}
          />
        )}
        <Modal
          name="reviews-customer-photos-grid"
          className="reviews-customer-photos-grid"
          id="reviewsCustomerPhotosGrid"
          closeButton
          disableOutsideClick
          onClose={() => {
            hideModal('reviews-customer-photos-grid');
          }}
        >
          <CustomerPhotoGridModal
            fetchData={fetchData}
            loading={loading}
            viewPhotoReviews={viewPhotoReviews}
            pageNumber={pageNumber}
            app="DESKTOP"
          />
        </Modal>
        <Modal
          ariaLabel="Review with photo modal"
          name="reviews-single-photo"
          className="reviews-single-photo"
          id="reviewsSinglePhoto"
          closeButton
          disableOutsideClick
          onClose={() => {
            gtmEventPush({
              event: 'reviews_rating_interactions',
              event_category: 'reviews_rating_interactions',
              event_action: 'photo interaction',
              event_label: 'cross',
              ...(product_id.length > 0 && { product_id }),
              ...(productName.length > 0 && { product_name: productName }),
              ...(product_brick.length > 0 && { product_brick }),
              pageType: 'PDP',
              store_type: 'ajio'
            });
            hideModal('reviews-single-photo');
          }}
        >
          <ReviewSinglePhotoModal app="DESKTOP" productDetails={productDetails} />
        </Modal>
      </div>
    </>
  );
};

export default connector(ProductReviewsDesktop);
